import styled from 'styled-components';

export const UnsubscribeContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 24px;
  padding-top: 50px;
`;
